import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { environment } from 'environments/environment';
import { AuthenticationService} from '../authentication/authentication.service';

@Injectable()
export class UploadCdrService {

  @Output() filterData: EventEmitter<any> = new EventEmitter();
  @Output() selectedTenant: number = 0;

  constructor(private http: HttpClient, private authService: AuthenticationService) { }

  getHeaders(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.authService.token);
    return headers;
  }

  setTenant(filter){
    this.selectedTenant = filter;
    this.filterData.emit(filter);
  }

  getTenants(): Observable<any>  {
    return this.http.get(environment.API + '/filter/tenants/', { headers: this.getHeaders() });
  }

  importFile(fileType: string, data: any) {
    return this.http.post(environment.ImportsAPI + '/import/' + fileType + '/', data, { headers: this.getHeaders() });
  }

  downloadConsumption() {
    let headers: HttpHeaders = this.getHeaders();
    headers = headers.append('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;')
    return this.http.get(environment.API + '/api/consumption/download/', {headers: headers});
  }

  downloadOptimization() {
    let headers: HttpHeaders = this.getHeaders();
    headers = headers.append('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    
    //return this.http.get('assets/data/OptimizationFile.xlsx', { headers: headers, responseType: 'blob' });
    return this.http.get(environment.API + '/api/optimization/download/', { headers: headers });
  }

  chargeOptimization(amount) {
    return this.http.post(environment.API + '/api/chargeoptimization/', {amount: amount}, { headers: this.getHeaders() });
  }

  getProgress(tenant): Observable<any> {
    return this.http.get(environment.AdditionalFeatAPI + '/aF/progressBar/' + tenant, { headers: this.getHeaders() });
  } 

}



// WEBPACK FOOTER //
// ./src/app/views/upload-cdr-file/upload-cdr-file.service.ts